<template>
  <div class="rich">
    <div class="type">
      <div class="label">内容类型</div>
      <div class="form">
        <el-select id="content_type_select" size="mini" v-model="contentType" @change="selectContentType" @visible-change="visibleChangeContentType" :disabled="editorStatus === false">
          <el-option value="content_type_0001" label="引题"></el-option>
          <el-option value="content_type_0002" label="标题"></el-option>
          <el-option value="content_type_0003" label="副标题"></el-option>
          <el-option value="content_type_0004" label="摘要"></el-option>
          <el-option value="content_type_0005" label="作者"></el-option>
          <el-option value="content_type_0006" label="图片说明"></el-option>
          <el-option value="content_type_0007" label="内容"></el-option>
          <el-option value="content_type_0008" label="小标题"></el-option>
          <el-option value="content_type_0009" label="来源"></el-option>
        </el-select>
      </div>
    </div>
    <div class="type">
      <div class="label">对齐方式</div>
      <div class="form">
        <el-select id="justify_type_select" size="mini" v-model="justifyType" @change="selectJustifyType" @visible-change="visibleChangeJustifyType">
          <el-option value="justify" label="端齐居左"></el-option>
          <el-option value="left" label="居左"></el-option>
          <el-option value="center" label="居中"></el-option>
          <el-option value="right" label="居右"></el-option>
          <el-option value="" label="默认"></el-option>
        </el-select>
      </div>
    </div>

    <div class="btns">
      <DigitalUploadVideoTc
        ref="digitalUploadVideoTc"
        style="width: 0;"
        :maxSize="maxSize"
        :sizeTip="sizeTip"
        :maxSpace="maxSpace"
        typeTip="请上传H264标准的mp4文件"
        accept="video/mp4"
        @updateState="updateVideoTcState"
        @uploadSuccess="uploadVideoTcSuccess"
        @uploadError="uploadVideoTcError"
        @updatePercentage="updateVideoTcPercentage"
        @toSpace="updateVideoTcToSpace"
      ></DigitalUploadVideoTc>
      <DigitalUploadAudio
        ref="digitalUploadAudio"
        @updateAudioState="updateAudioState"
        @updateAudioProgress="updateAudioProgress"
        @updateAudioSuccess="updateAudioSuccess"
        @updateAudioComplete="updateAudioComplete"
        @updateAudioError="updateAudioError"
      >
      </DigitalUploadAudio>
      <DigitalUploadImage
        ref="digitalUploadImage"
        @updateImageState="updateImageState"
        @updateImageProgress="updateImageProgress"
        @updateImageSuccess="updateImageSuccess"
        @updateImageComplete="updateImageComplete"
        @updateImageError="updateImageError"
      >
      </DigitalUploadImage>
      <DigitalUploadWord ref="digitalUploadWord" @updateWordState="updateWordState" @updateWordProgress="updateWordProgress" @updateWordSuccess="updateWordSuccess" @updateWordError="updateWordError">
      </DigitalUploadWord>
      <DigitalHyperLink ref="DigitalHyperLinkRef" @setSectionToParagraphLink="setSectionToParagraphLink" @get-dayang-Id="(val) => (dayangId = val)" />
      <el-button size="mini" @click="digitalUploadImage">
        <span v-if="uploadImageStatus">{{ uploadImageProgress }}%</span>
        <span v-else>图片</span>
      </el-button>
      <el-button size="mini" @click="digitalUploadAudio">
        <span v-if="uploadAudioStatus">{{ uploadAudioProgress }}%</span>
        <span v-else>音频</span>
      </el-button>
      <el-button size="mini" @click="digitalUploadVideo">
        <span v-if="uploadVideoStatus">{{ uploadVideoProgress }}%</span>
        <span v-else>视频</span>
      </el-button>
      <el-button v-if="!isPaper" size="mini" @click="digitalUploadWord">
        <span v-if="uploadWordStatus">{{ uploadWordProgress }}%</span>
        <span v-else>文档</span>
      </el-button>
      <!--      <el-button size="mini" @click="undo">撤销</el-button>-->
      <!--      <el-button size="mini" @click="redo">恢复</el-button>-->
    </div>
    <div class="type custom-editor-toolbar" :class="{ active: editorFocus }" @mousedown.prevent="() => {}">
      <div class="label">编　　辑</div>
      <div class="form">
        <div class="btn bold" title="粗体" @click="handleCustomEditorToolbarItemClick('bold')"></div>
        <div class="btn italic" title="斜体" @click="handleCustomEditorToolbarItemClick('italic')"></div>
        <div class="btn underline" title="下划线" @click="handleCustomEditorToolbarItemClick('underline')"></div>
        <div class="btn spaces" title="全角空格" @click="handleCustomEditorToolbarItemClick('specialBlanks')"></div>
        <div class="btn link" title="上接下转" @click="handleCustomEditorToolbarItemClick('hyperLink')"></div>
        <div class="btn undo" title="撤销" @click="handleCustomEditorToolbarItemClick('undo')"></div>
        <div class="btn redo" title="重做" @click="handleCustomEditorToolbarItemClick('redo')"></div>
      </div>
    </div>
    <div class="type custom-editor-toolbar" @mousedown.prevent="() => {}">
      <div class="label">朗读效果</div>
      <div class="form">
        <div class="btn pause" :class="{ active: editorFocus }" title="静音停顿" @click="handleReadEffectSetingClick('break')"></div>
        <div class="btn speed" :class="{ active: editorSelectText.length > 1 }" title="语速" @click="handleReadEffectSetingClick('speed')"></div>
        <div class="btn pinyin" :class="{ active: editorSelectText.length === 1 }" title="读音" @click="handleReadEffectSetingClick('phoneme')"></div>
        <div class="btn clear" :class="{ active: editorFocus }" title="清除朗读标记" @click="handleReadEffectSetingClick('clear')"></div>
      </div>
    </div>
    <div class="editor" v-if="!editorDisabled" @keyup.delete="handleEditorDelete" @keyup.backspace="handleEditorDelete">
      <Toolbar ref="toolbar" :editor="editor" :defaultConfig="toolbarConfig" :mode="mode" v-show="false" />
      <Editor
        id="editor-root-box"
        class="editor-root editor_preview"
        v-model="html"
        :defaultConfig="editorConfig"
        mode="simple"
        @onCreated="onCreated"
        @onFocus="onFocus"
        @onBlur="onBlur"
        @onChange="onChange"
        @onDestroyed="onDestroy"
        @customPaste="customPaste"
      />
    </div>
    <el-dialog
      :title="isSettingPinyin ? '读音设置' : '语速设置'"
      custom-class="setting-dialog"
      center
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :append-to-body="true"
      :handleCancel="handleCancel"
      width="260px"
      top="calc( 50vh - 100px )"
    >
      <div class="editorSelectText" v-if="isSettingPinyin">{{ editorSelectText }}</div>
      <el-form class="dialog-form" label-width="auto" :rules="settingRules" ref="settingDialogForm" :model="settingForm">
        <el-form-item label="读音:" v-if="isSettingPinyin" prop="pinyin">
          <el-input v-model="settingForm.pinyin" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="语速:" v-if="isSettingSpeed" prop="speed">
          <el-input type="number" v-model.number="settingForm.speed" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <div class="dialog-footer-item confirm" @click="debouncedSettingConfirm()">保存</div>
        <div class="dialog-footer-item cancel" @click="handleCancel">取消</div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="clearDialogVisible" title="提示" custom-class="clear-confirm-dialog" center :close-on-click-modal="false" :append-to-body="true" top="calc( 50vh - 100px )" width="450px">
      <div class="prompt">此操作将删除文章中所有语音朗读标记，保存后不可恢复，是否确认删除？</div>
      <div class="dialog-footer">
        <div class="dialog-footer-item cancel" @click="clearDialogVisible = false">取消</div>
        <div class="dialog-footer-item confirm" @click="handleClearConfirm">确定</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { h } from 'snabbdom'
import { Boot, SlateEditor, SlateTransforms, DomEditor } from '@wangeditor/editor'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import DigitalUploadVideoTc from './DigitalUploadVideoTc'
import DigitalUploadAudio from './DigitalUploadAudio'
import DigitalUploadImage from './DigitalUploadImage'
import DigitalHyperLink from '@components/digital/DigitalHyperLink'
import setBook from '../../api/setBook'
import getBook from '@api/getBook'
import { formatDigitalArticle, initWordArticle } from '@/utils'
import DigitalUploadWord from '@components/digital/DigitalUploadWord'
import { debounce } from 'lodash'

function withVoiceControl(editor) {
  const { isInline, isVoid } = editor
  const newEditor = editor
  newEditor.isInline = (elem) => {
    const type = DomEditor.getNodeType(elem)
    if (type === 'silent' || type === 'pinyin' || type === 'speed') return true // 针对 type: attachment ，设置为 inline
    return isInline(elem)
  }
  newEditor.isVoid = (elem) => {
    const type = DomEditor.getNodeType(elem)
    if (type === 'silent' || type === 'pinyin' || type === 'speed') return true
    return isVoid(elem)
  }
  return newEditor
}
//静音停顿
const silent = {
  type: 'silent',
  children: [{ text: '' }]
}
function renderSilent(elem, children, editor) {
  return h(
    // HTML tag
    'span',
    // HTML 属性、样式、事件
    {
      props: { contentEditable: false, className: 'break' } // HTML 属性，驼峰式写法
    },
    ['停顿']
  )
}
function silentToHtml(ele, childrenHTML) {
  return `<span data-w-e-type="silent" data-w-e-is-inline data-w-e-is-void>[p500]</span>`
}
function parseSilentHtml(domElem, children, editor) {
  return {
    type: 'silent',
    children: [{ text: '' }]
  }
}

//读音
function pinyinToHtml(ele, childrenHTML) {
  return `<span data-w-e-type="pinyin" data-w-e-is-inline data-w-e-is-void data-hanzi="${ele.hanzi}" data-pinyin="${ele.pinyin}" data-timestamp="${ele.timestamp}">[=${ele.pinyin}]</span>`
}
function parsePinyinHtml(domElem, children, editor) {
  return {
    type: 'pinyin',
    pinyin: domElem.getAttribute('data-pinyin'),
    hanzi: domElem.getAttribute('data-hanzi'),
    timestamp: domElem.getAttribute('data-timestamp'),
    children: [{ text: '' }]
  }
}

//语速
function speedToHtml(ele, childrenHTML) {
  return `<span data-w-e-type="speed" data-w-e-is-inline data-w-e-is-void data-speed-start="${ele.start}" data-speed="${ele.speed}" data-timestamp="${ele.timestamp}"></span>`
}
function parseSpeedHtml(domElem, children, editor) {
  return {
    type: 'speed',
    speed: domElem.getAttribute('data-speed'),
    start: domElem.getAttribute('data-speed-start'),
    timestamp: domElem.getAttribute('data-timestamp'),
    children: [{ text: '' }]
  }
}

export default {
  components: {
    DigitalUploadWord,
    Editor,
    Toolbar,
    DigitalUploadImage,
    DigitalUploadAudio,
    DigitalUploadVideoTc,
    DigitalHyperLink
  },
  name: 'DigitalRichText',
  props: {
    // v-model
    value: {
      type: String,
      default: ''
    },
    editorDisabled: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value(val) {
      this.html = val
      setTimeout(() => {
        let abstracts = document.getElementsByClassName('content_type_0004')
        if (abstracts && abstracts.length > 0) {
          let last = abstracts[abstracts.length - 1]
          last.style['border-bottom'] = '1px dotted #777777'
          for (let i = 0; i < abstracts.length; i++) {
            if (i < abstracts.length - 1) {
              abstracts[i].style['border-bottom'] = 'none'
            }
          }
        }
      }, 300)
    },
    input(val) {
      this.$emit('input', val)
    }
  },
  data() {
    var validatePinyin = (rule, value, callback) => {
      console.log(value)
      if (!value) {
        return callback(new Error('读音不能为空'))
      } else {
        if (/^[a-zA-Z]+[12345]$/.test(value)) {
          callback()
        } else {
          callback('读音格式不正确')
        }
      }
    }
    return {
      editor: null,
      html: '',
      input: '',
      contentType: 'content_type_0007',
      justifyType: '',
      contentTypeStatus: false,
      editorFocus: false,
      editorStatus: false,
      editorConfig: {
        hoverbarKeys: {
          image: {
            menuKeys: []
          },
          video: {
            menuKeys: []
          },
          code: {
            menuKeys: []
          }
        }
      },
      uploadImageStatus: false,
      uploadImageProgress: 0,
      uploadAudioStatus: false,
      uploadAudioProgress: 0,
      uploadVideoStatus: false,
      uploadVideoProgress: 0,
      uploadWordStatus: false,
      uploadWordProgress: 0,
      addFileAttachIds: [],
      mode: 'simple',
      toolbarConfig: {
        toolbarKeys: [
          'bold',
          'italic',
          'underline',
          'specialBlanks',
          'hyperLink',
          /*{
            iconSvg: '<svg viewBox="0 0 1024 1024"><path d="M0 64h1024v128H0z m384 192h640v128H384z m0 192h640v128H384z m0 192h640v128H384zM0 832h1024v128H0z m0-128V320l256 192z"></path></svg>',
            key: 'group-indent',
            menuKeys: ['indent', 'delIndent'],
            title: '缩进'
          },*/
          /* {
            iconSvg:
              '<svg viewBox="0 0 1024 1024"><path d="M768 793.6v102.4H51.2v-102.4h716.8z m204.8-230.4v102.4H51.2v-102.4h921.6z m-204.8-230.4v102.4H51.2v-102.4h716.8zM972.8 102.4v102.4H51.2V102.4h921.6z"></path></svg>',
            key: 'group-justify',
            menuKeys: ['justifyLeft', 'justifyRight', 'justifyCenter'],
            title: '对齐方式'
          },*/
          'undo',
          'redo'
        ]
      },
      dayangId: '',
      isJustify: false,
      editorSelectText: '', //编辑器选中的文本
      isSettingPinyin: false, //是否正在设置拼音
      isSettingSpeed: false, //是否正在设置音速
      dialogVisible: false, //拼音、音速设置弹窗显示控制
      settingForm: {
        pinyin: '', //设置的拼音
        speed: '' //设置的语速
      },
      pinyinEditElem: null,
      speedEditElem: null,
      settingRules: {
        pinyin: [
          {
            validator: validatePinyin,
            trigger: 'blur'
          }
        ],
        speed: [
          { required: true, message: '语速不能为空', trigger: 'blur' },
          {
            type: 'integer',
            min: 1, // 最小值限制
            max: 100, // 最大值限制
            message: '语速必须是在 1-100 之间的整数',
            trigger: 'blur'
          }
        ]
      },
      clearDialogVisible: false,
      editorDom: null
    }
  },
  computed: {
    maxSize() {
      return 100
    },
    sizeTip() {
      return `视频大小不能超过100M`
    },
    alreadyUse() {
      return this.$store.state.manage.alreadyUse || 0
    },
    totalSpace() {
      return this.$store.state.manage.allSpace
    },
    maxSpace() {
      return this.totalSpace * 1024 - this.alreadyUse
    },
    isPaper() {
      return this.$route.query.type === 'paper'
    }
  },
  methods: {
    renderPinyin(elem, children, editor) {
      return h(
        // HTML tag
        'span',
        // HTML 属性、样式、事件
        {
          props: { contentEditable: false, className: 'pinyin' }, // HTML 属性，驼峰式写法
          on: {
            dblclick: () => {
              this.pinyinEditElem = elem
              this.settingForm.pinyin = elem.pinyin
              this.editorSelectText = elem.hanzi
              this.dialogVisible = true
              this.isSettingPinyin = true
            }
          }
        },
        [elem.pinyin]
      )
    },
    renderSpeed(elem, children, editor) {
      console.log(elem)
      return h(
        // HTML tag
        'span',
        // HTML 属性、样式、事件
        {
          props: { contentEditable: false, className: 'speed', style: elem.start === true || elem.start === 'true' ? 'display:none;' : '' }, // HTML 属性，驼峰式写法
          on: {
            dblclick: () => {
              this.speedEditElem = elem
              this.settingForm.speed = elem.speed
              this.dialogVisible = true
              this.isSettingSpeed = true
            }
          }
        },
        ['语速' + elem.speed]
      )
    },
    /**
     * 获取附件数据合集
     * @param fileAttachIds 原数据已存在的附件IDS
     * @return Array 返回包括当前富文本中的附件IDS、待添加的附件IDS、待删除的附件IDS
     */
    getFileAttachArray(fileAttachIds) {
      // 获取编辑器中当前的附件IDS
      let imageArray = this.editor.getElemsByType('image')
      let videoArray = this.editor.getElemsByType('video')
      let contentaudioArray = this.editor.getElemsByType('contentaudio')
      let currentAttachArray = []
      for (let a in imageArray) {
        if (imageArray.hasOwnProperty(a)) {
          currentAttachArray.push(parseInt(imageArray[a].src.substring(imageArray[a].src.indexOf('?id=') + 4)) || 0)
        }
      }
      for (let a in videoArray) {
        if (videoArray.hasOwnProperty(a)) {
          currentAttachArray.push(parseInt(videoArray[a].src.substring(videoArray[a].src.indexOf('?id=') + 4)) || 0)
        }
      }
      for (let a in contentaudioArray) {
        if (contentaudioArray.hasOwnProperty(a)) {
          currentAttachArray.push(parseInt(contentaudioArray[a].src.substring(contentaudioArray[a].src.indexOf('?id=') + 4)) || 0)
        }
      }
      // 去掉空的ID
      // 正常情况下应该不会有空的，主要用于过滤掉一些非正常情况下的数据
      // 比喻原始给到的内容中存在附件信息，但并不是本功能生成出来的数据，所以解析过来后，它本身可能是没有附件ID的
      let currentAttachIds = []
      for (let a in currentAttachArray) {
        if (currentAttachArray.hasOwnProperty(a)) {
          if (currentAttachArray[a] !== 0) {
            currentAttachIds.push(currentAttachArray[a])
          }
        }
      }
      // 通过与fileAttachIds进行比对，判断哪些是被删除掉的
      let deleteFileAttachIds = []
      for (let a in fileAttachIds) {
        if (fileAttachIds.hasOwnProperty(a)) {
          if (currentAttachIds.indexOf(parseInt(fileAttachIds[a])) === -1) {
            deleteFileAttachIds.push(parseInt(fileAttachIds[a]))
          }
        }
      }
      // 转换待添加的附件IDS
      let addFileAttachIds = []
      for (let a in this.addFileAttachIds) {
        if (this.addFileAttachIds.hasOwnProperty(a)) {
          addFileAttachIds.push(this.addFileAttachIds[a])
        }
      }
      //
      return {
        fileAttachIds: currentAttachIds,
        deleteFileAttachIds: deleteFileAttachIds,
        addFileAttachIds: addFileAttachIds
      }
    },
    ////////////////////////////////////////////////////////////////////////////////////////////////////////
    // 上传图片、音频、视频相关方法
    ////////////////////////////////////////////////////////////////////////////////////////////////////////
    digitalUploadImage() {
      if (this.uploadImageStatus === false) {
        this.$refs.digitalUploadImage.upload()
      } else {
        this.$alert(`正在上传音频中，请稍待`, '提示', {
          confirmButtonText: '确定'
        })
      }
    },
    updateImageState(state) {
      if (state === 'start') {
        this.uploadImageStatus = true
      }
    },
    updateImageProgress(percentage) {
      this.uploadImageProgress = parseInt(percentage)
      if (this.uploadImageProgress > 100) {
        this.uploadImageProgress = 100
      }
    },
    updateImageSuccess(res) {
      // 恢复编辑器的选中内容及状态
      this.editor.restoreSelection()
      if (this.editor.selection === null) {
        this.selectEnd(this.editor)
      }
      // 添加图片元素至编辑器
      this.editor.insertNode({
        type: 'image',
        src: res.data.path + '?id=' + res.data.id,
        href: res.data.path,
        children: [{ text: '' }]
      })
      // 恢复编辑器的选中内容及状态《这里主要目的用于恢复光标》
      setTimeout(() => {
        this.editor.restoreSelection()
      }, 100)
      // 回调上传成功的音频ID
      this.addFileAttachIds.push(res.data.id)
    },
    updateImageComplete() {
      // 恢复上传状态
      this.uploadImageProgress = 0
      this.uploadImageStatus = false
    },
    updateImageError() {
      // 恢复上传状态
      setTimeout(() => {
        this.uploadImageProgress = 0
        this.uploadImageStatus = false
      }, 100)
    },
    digitalUploadAudio() {
      if (this.uploadAudioStatus === false) {
        this.$refs.digitalUploadAudio.upload()
      } else {
        this.$alert(`正在上传音频中，请稍待`, '提示', {
          confirmButtonText: '确定'
        })
      }
    },
    updateAudioState(state) {
      if (state === 'start') {
        this.uploadAudioStatus = true
      }
    },
    updateAudioProgress(percentage) {
      this.uploadAudioProgress = parseInt(percentage)
      if (this.uploadAudioProgress > 100) {
        this.uploadAudioProgress = 100
      }
    },
    updateAudioSuccess(res) {
      // 恢复编辑器的选中内容及状态
      this.editor.restoreSelection()
      if (this.editor.selection === null) {
        this.selectEnd(this.editor)
      }
      // 添加音频元素至编辑器
      this.editor.insertNode({
        type: 'contentaudio',
        src: res.data.path + '?id=' + res.data.id,
        children: [{ text: '' }]
      })
      // 恢复编辑器的选中内容及状态《这里主要目的用于恢复光标》
      setTimeout(() => {
        this.editor.restoreSelection()
      }, 100)
      // 回调上传成功的音频ID
      this.addFileAttachIds.push(res.data.id)
    },
    updateAudioComplete() {
      // 恢复上传状态
      this.uploadAudioProgress = 0
      this.uploadAudioStatus = false
    },
    updateAudioError() {
      // 恢复上传状态
      setTimeout(() => {
        this.uploadAudioProgress = 0
        this.uploadAudioStatus = false
      }, 100)
    },
    digitalUploadVideo() {
      if (this.uploadVideoStatus === false) {
        this.$refs.digitalUploadVideoTc.addMedia()
      } else {
        this.$alert(`正在上传视频中，请稍待`, '提示', {
          confirmButtonText: '确定'
        })
      }
    },
    updateVideoTcState: function(state) {
      if (state === 'uploading') {
        this.uploadVideoStatus = true
      } else if (state === 'done') {
        // 恢复上传状态
        this.uploadVideoProgress = 0
        this.uploadVideoStatus = false
      }
    },
    updateVideoTcPercentage: function(percent) {
      this.uploadVideoProgress = parseInt((percent * 100).toString())
      if (this.uploadVideoProgress > 100) {
        this.uploadVideoProgress = 100
      }
    },
    uploadVideoTcSuccess: function(uploaderInfo) {
      // 上传至方正
      setBook
        .addFileAttach({
          fileName: uploaderInfo.title,
          creator: uploaderInfo.creator,
          size: uploaderInfo.size,
          format: uploaderInfo.type,
          path: uploaderInfo.mediaUrl,
          fileType: 'video',
          module: 'epaper',
          status: 1,
          storageType: 'VOD'
        })
        .then(({ data, status }) => {
          if (status === 200 && data.status === 0) {
            // 恢复编辑器的选中内容及状态
            this.editor.restoreSelection()
            if (this.editor.selection === null) {
              this.selectEnd(this.editor)
            }
            // 添加视频元素至编辑器
            this.editor.insertNode({
              type: 'video',
              src: uploaderInfo.mediaUrl + '?id=' + data.data.id + '&fileid=' + uploaderInfo.fileId + '&appid=' + data.data.appID,
              children: [{ text: '' }]
            })
            // 恢复编辑器的选中内容及状态《这里主要目的用于恢复光标》
            setTimeout(() => {
              this.editor.restoreSelection()
            }, 100)
            // 回调上传成功的视频ID
            this.addFileAttachIds.push(data.data.id)
          }
        })
    },
    uploadVideoTcError: function() {
      // 恢复上传状态
      setTimeout(() => {
        this.uploadVideoProgress = 0
        this.uploadVideoStatus = false
      }, 100)
    },
    updateVideoTcToSpace() {
      //
    },
    digitalUploadWord() {
      if (this.uploadWordStatus === false) {
        this.$refs.digitalUploadWord.upload()
      } else {
        this.$alert(`正在上传文档中，请稍待`, '提示', {
          confirmButtonText: '确定'
        })
      }
    },
    updateWordState(state) {
      if (state === 'start') {
        this.uploadWordStatus = true
      } else {
        // 恢复上传状态
        this.uploadWordProgress = 0
        this.uploadWordStatus = false
      }
    },
    updateWordProgress(percent) {
      this.uploadWordProgress = parseInt((percent * 100).toString())
      if (this.uploadWordProgress > 100) {
        this.uploadWordProgress = 100
      }
    },
    updateWordSuccess(uploaderInfo) {
      this.editor.clear()
      this.uploadWordProgress = 0
      this.uploadWordStatus = false
      if (uploaderInfo.status === 0) {
        setTimeout(() => {
          this.html = initWordArticle(uploaderInfo.data.content)
        }, 100)
      }
    },
    updateWordError(error) {
      this.uploadWordProgress = 0
      this.uploadWordStatus = false
    },
    ////////////////////////////////////////////////////////////////////////////////////////////////////////
    // 公共方法
    ////////////////////////////////////////////////////////////////////////////////////////////////////////
    /**
     * 获取已选中的节点，无选中节点，则返回NULL
     */
    getSelectedNode(editor) {
      const nodeEntries = SlateEditor.nodes(editor)
      try {
        if (nodeEntries != null) {
          for (let nodeEntry of nodeEntries) {
            console.log(nodeEntry)
            const [node] = nodeEntry
            if (node.type !== undefined) {
              return node
            }
          }
        }
      } catch (e) {}
      return null
    },
    /**
     * 选择结尾
     */
    selectEnd(editor) {
      let endindex = editor.children.length - 1
      let children = editor.children[endindex]?.children || []
      let offset = 0
      for (let a in children) {
        if (children.hasOwnProperty(a)) {
          if (children[a].text) {
            offset += children[a].text.length
          }
        }
      }
      const newSelection = {
        anchor: { path: [endindex, 0], offset: offset },
        focus: { path: [endindex, 0], offset: offset }
      }
      this.editor.select(newSelection)
    },
    ////////////////////////////////////////////////////////////////////////////////////////////////////////
    // 外部操作事件处理
    ////////////////////////////////////////////////////////////////////////////////////////////////////////
    /**
     * 选择内容类型
     */
    selectContentType(contentType) {
      // 恢复编辑器的选中内容及状态
      this.editor.restoreSelection()
      // 获取当前选择的内容节点
      let node = this.getSelectedNode(this.editor)
      // 更新当前内容节点
      if (node !== null) {
        if (node.type === 'contenttype' || node.type === 'paragraph') {
          SlateTransforms.setNodes(this.editor, {
            type: 'contenttype',
            contentType: contentType
          })
        }
      }
      // this.justifyType = 'center'
      // 恢复编辑器的选中内容及状态《这里主要目的用于恢复光标》
      setTimeout(() => {
        this.editor.restoreSelection()
        this.contentTypeStatus = false
        this.editorStatus = false
      }, 100)
    },
    visibleChangeContentType(status) {
      if (status === false) {
        if (this.editorFocus === false) {
          this.editorStatus = false
        }
      }
    },
    /**
     * 撤销
     */
    undo() {
      this.editor.undo()
    },
    /**
     * 恢复
     */
    redo() {
      this.editor.redo()
    },
    ////////////////////////////////////////////////////////////////////////////////////////////////////////
    // 编辑器内部事件处理
    ////////////////////////////////////////////////////////////////////////////////////////////////////////
    onCreated(editor) {
      this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
      this.watchCLick()
      this.tcplayer()
      // 监听上转下接按钮点击
      this.editor.on('hyperLinkClick', () => {
        this.hyperlinkClick()
      })
    },
    onFocus() {
      this.editorFocus = true
      this.editorStatus = true
    },
    onBlur() {
      console.log(123)
      this.editorFocus = false
      if (this.contentTypeStatus === false) {
        this.editorStatus = false
      }
    },
    onChange(editor) {
      console.log('onchange', editor)
      //处理选中文字后，进行设置时，弹窗出现，editor失去焦点，会触发onChange，给editorSelectText赋值为空
      try {
        if (!this.isSettingPinyin && !this.isSettingSpeed) {
          this.editorSelectText = editor.getSelectionText()
        }
      } catch (error) {
        console.log(error)
      }
      //处理语速删除的情况
      let newHtml = this.html
      if (!this.isSettingSpeed) {
        let endReg = /<span data-w-e-type="speed" data-w-e-is-inline="" data-w-e-is-void="" data-speed-start="false" data-speed="\d+" data-timestamp="\d+"><\/span>/g
        this.oldHtml = this.oldHtml || ''
        let newHtmlEndTagMatch = this.html.match(endReg)
        let oldHtmlEndTagMatch = this.oldHtml.match(endReg)
        console.log(newHtmlEndTagMatch)
        console.log(oldHtmlEndTagMatch)
        let newMatchLength = newHtmlEndTagMatch ? newHtmlEndTagMatch.length : 0
        let oldMatchLength = oldHtmlEndTagMatch ? oldHtmlEndTagMatch.length : 0
        if (oldMatchLength > newMatchLength) {
          //是语速删除
          for (let index = 0; index < oldMatchLength; index++) {
            let oldMatchStr = oldHtmlEndTagMatch[index]
            let newMatchStr = newHtmlEndTagMatch ? newHtmlEndTagMatch[index] : ''
            if (newMatchStr !== oldMatchStr) {
              let oldEndTagIndex = this.oldHtml.indexOf(oldMatchStr)
              let oldStartTagStr = oldMatchStr.replace('false', 'true')
              let oldStartTagIndex = this.oldHtml.indexOf(oldStartTagStr)
              let rangeHtml = this.html.slice(oldStartTagIndex, oldEndTagIndex)
              let newRangeHtml = rangeHtml.replace(oldStartTagStr, '').replaceAll(' style="background-color: rgb(204, 228, 255);"', '')
              console.log(rangeHtml)
              console.log(newRangeHtml)
              console.log(this.html.replace(rangeHtml, newRangeHtml))
              newHtml = this.html.replace(rangeHtml, newRangeHtml)
              this.oldHtml = this.html
              this.html = newHtml
              return
            }
          }
        }
      }
      console.log(67676)
      // 获取当前选择的内容节点
      let node = this.getSelectedNode(editor)

      // 如果是内容类型元素，则同步内容类型选项
      if (node !== null) {
        if (node.type === 'contenttype') {
          this.contentType = node.contentType
        } else {
          this.contentType = 'content_type_0007'
        }
        this.justifyType = node.justifyType == 'undefined' ? '' : node.justifyType

        // 格式化当前类型
        if (node.type === 'paragraph') {
          SlateTransforms.setNodes(editor, {
            type: 'contenttype',
            contentType: 'content_type_0007'
          })
        }
      }
      //嵌入图前后输入换段符，图片独立成行
      const regex = /(<div[^\/>]*class=\"content_type content_type_0007\" data-content-type=\"content_type_0007\")([^\/>]*>\s*<img[^>]*>\s*<\/div>)/g
      const matches = this.html.match(regex)
      if (matches) {
        matches.forEach((str) => {
          const newStr = str.replaceAll('content_type_0007', 'content_type_0006')
          newHtml = newHtml.replace(str, newStr)
        })
      }
      this.html = newHtml
      // 同步内容至v-model
      this.input = this.html
      this.oldHtml = this.html
      // 更新腾讯云播放器
      this.tcplayer()
    },
    onDestroy() {
      this.removeWatchClick()
    },
    customPaste(editor, event, callback) {
      let htmlContent = event.clipboardData.getData('text/html')
      if (htmlContent.indexOf('content_type_') > -1 || htmlContent.indexOf('data-slate-node') > -1) {
        callback(true)
      } else {
        let data1 = event.clipboardData.getData('text/plain')
        let contents = data1.split('\n')
        for (let a in contents) {
          if (contents.hasOwnProperty(a)) {
            this.editor.insertNode({
              type: 'contenttype',
              contentType: 'content_type_0007',
              justifyType: '',
              children: [{ text: contents[a].trim() }]
            })
          }
        }
        callback(false)
      }
    },
    watchCLick() {
      document.getElementById('editor-root-box').addEventListener('click', this.editorClick)
    },
    removeWatchClick() {
      document.getElementById('editor-root-box')?.removeEventListener('click', this.editorClick)
    },
    handleTId(contentType, justifyType) {
      let textIndent
      switch (contentType) {
        case 'content_type_0004':
        case 'content_type_0007':
          if (justifyType == 'justify' || !justifyType || justifyType == 'undefined' || justifyType == 'justifyType') {
            textIndent = '2em'
          } else {
            textIndent = '0'
          }
          break
        case 'content_type_0009':
          textIndent = '5em'
          break
        case 'content_type_0006':
          if (justifyType == 'justify' || justifyType == 'undefined' || justifyType == 'justifyType') {
            textIndent = '2em'
          } else {
            textIndent = '0'
          }
        default:
          textIndent = '0'
      }

      if (justifyType == 'left') {
        textIndent = '0'
      }

      return textIndent
    },

    ////////////////////////////////////////////////////////////////////////////////////////////////////////
    // 自定义元素：几大主题内容、图片、音频、视频
    ////////////////////////////////////////////////////////////////////////////////////////////////////////
    elContentType_renderElems(elem, children) {
      // let textIndent = ['content_type_0004', 'content_type_0007'].indexOf(elem.contentType) > -1 ? '2em' : '0'
      // if (this.isJustify) {
      //   switch (elem.contentType) {
      //     case 'content_type_0004':
      //     case 'content_type_0007':
      //       if (elem.justifyType == 'justify' || !elem.justifyType || elem.justifyType == 'undefined' || elem.justifyType == 'elem.justifyType') {
      //         textIndent = '2em'
      //       } else {
      //         textIndent = '0'
      //       }
      //       break
      //     case 'content_type_0006':
      //       if (elem.justifyType == 'justify' || elem.justifyType == 'undefined' || elem.justifyType == 'elem.justifyType') {
      //         textIndent = '2em'
      //       } else {
      //         textIndent = '0'
      //       }
      //     default:
      //       textIndent = '0'
      //   }
      // } else {
      //   textIndent = ['content_type_0004', 'content_type_0007'].indexOf(elem.contentType) > -1 ? '2em' : '0'
      // }
      //
      // if (elem.justifyType === 'left') {
      //   textIndent = '0'
      // }
      return h(
        'div',
        {
          props: { className: elem.contentType }
          // style: { textAlign: elem.justifyType, textIndent }
        },
        children
      )
    },
    elContentType_elemsToHtml(elem, childrenHtml) {
      let html = `<div class="content_type ${elem.contentType}" data-content-type="${elem.contentType}"  data-w-e-type="contenttype" justify-type="${elem.justifyType}" hyperLinkId="${this.dayangId}" >${childrenHtml}</div>`
      return html
    },
    elContentType_parseElemsHtml(domElem, children) {
      const justifyType = domElem.getAttribute('justify-type') || ''
      const contentType = domElem.getAttribute('data-content-type') || ''
      const indent = this.handleTId(contentType, justifyType)
      return {
        type: 'contenttype',
        contentType,
        justifyType,
        indent,
        children: children
      }
    },
    elContentAudio_renderElems(elem) {
      const audio = h(
        'audio',
        {
          props: { src: elem.src, controls: true },
          style: {}
        },
        []
      )
      return h(
        'div',
        {
          props: { className: 'content_audio' },
          style: {},
          on: {
            click() {
              setTimeout(() => {
                document.onclick = () => {
                  this.elm.setAttribute('data-selected', false)
                  document.onclick = null
                }
              }, 500)
              document.onclick = null
              this.elm.setAttribute('data-selected', true)
            }
          }
        },
        [audio]
      )
    },
    elContentAudio_elemsToHtml(elem) {
      return `<div class="content_audio" data-src="${elem.src}" data-w-e-type="contentaudio"><audio src="${elem.src}" controls="true"></audio></div>`
    },
    elContentAudio_parseElemsHtml(domElem, children) {
      return {
        type: 'contentaudio',
        src: domElem.getAttribute('data-src') || '',
        children: children
      }
    },
    registerModule() {
      Boot.registerModule({
        renderElems: [
          {
            type: 'contenttype',
            renderElem: this.elContentType_renderElems
          },
          {
            type: 'contentaudio',
            renderElem: this.elContentAudio_renderElems
          },
          {
            type: 'silent',
            renderElem: renderSilent
          },
          {
            type: 'pinyin',
            renderElem: this.renderPinyin
          },
          {
            type: 'speed',
            renderElem: this.renderSpeed
          }
        ],
        elemsToHtml: [
          {
            type: 'contenttype',
            elemToHtml: this.elContentType_elemsToHtml
          },
          {
            type: 'contentaudio',
            elemToHtml: this.elContentAudio_elemsToHtml
          },
          {
            type: 'silent',
            elemToHtml: silentToHtml
          },
          {
            type: 'pinyin',
            elemToHtml: pinyinToHtml
          },
          {
            type: 'speed',
            elemToHtml: speedToHtml
          }
        ],
        parseElemsHtml: [
          {
            selector: 'div[data-w-e-type="contenttype"]',
            parseElemHtml: this.elContentType_parseElemsHtml
          },
          {
            selector: 'div[data-w-e-type="contentaudio"]',
            parseElemHtml: this.elContentAudio_parseElemsHtml
          },
          {
            selector: 'span[data-w-e-type="silent"]',
            parseElemHtml: parseSilentHtml
          },
          {
            selector: 'span[data-w-e-type="pinyin"]',
            parseElemHtml: parsePinyinHtml
          },
          {
            selector: 'span[data-w-e-type="speed"]',
            parseElemHtml: parseSpeedHtml
          }
        ],
        editorPlugin: withVoiceControl
      })
    },
    tcplayer() {
      let boxText = document.getElementById('editor-root-box')
      if (boxText) {
        let videoWidth = 313
        let videoElements = boxText.getElementsByTagName('video')
        for (let a in videoElements) {
          if (videoElements.hasOwnProperty(a)) {
            let fileid = ''
            let appid = ''
            if (videoElements[a].firstChild.src) {
              let query = videoElements[a].firstChild.src.split('?')
              let params = query[1].split('&')
              params.forEach((item) => {
                let pam = item.split('=')
                if (pam[0] === 'fileid') {
                  fileid = pam[1]
                } else if (pam[0] === 'appid') {
                  appid = pam[1]
                }
              })
            }
            if (fileid && appid) {
              let player = TCPlayer(videoElements[a], {
                fileID: fileid,
                appID: appid,
                width: videoWidth
              })
              player.on('error', function(error) {
                if (error.data.code === 1005) {
                  $('.vjs-modal-dialog-content .vjs-errors-content-container').html(
                    '<div class="vjs-errors-message" style="padding:70px 20px 0 20px;">云阅读平台正在对视频进行自动转码，请稍等5-10分钟后尝试播放。</div>'
                  )
                }
              })
            }
          }
        }
      }
    },
    addSelectionLinkStyle() {
      this.editor.addMark('color', 'blue')
      this.editor.addMark('underline', true)
    },
    resetAllLinkStyle() {
      try {
        this.editor.selectAll()
        this.editor.removeMark('color')
        this.editor.restoreSelection()
      } catch (e) {
        // this.editor.removeMark('color')
        // this.editor.restoreSelection()
      }
    },
    addLinkAtEnd() {
      // this.editor.restoreSelection()
      this.resetAllLinkStyle()
      const currentContentLines = this.editor.children.length
      SlateTransforms.insertNodes(this.editor, [{ type: 'contenttype', contentType: 'content_type_0007', hyperLinkId: `${this.dayangId}`, children: [{ text: '显示全部内容' }] }], {
        at: [currentContentLines]
      })
      const newSelection = {
        anchor: { path: [currentContentLines, 0], offset: 0 },
        focus: { path: [currentContentLines, 0], offset: 6 }
      }
      this.editor.select(newSelection)
      this.addSelectionLinkStyle()
      this.editor.deselect()
    },
    addNewLineForLink(text) {
      if (text) {
        this.resetAllLinkStyle()
      } else {
        return
      }
      const selection = this.editor.selection
      // 跨段落选择文本，不支持；只允许选中一个段落内文本
      if (selection.anchor.path[0] !== selection.focus.path[0]) {
        this.addLinkAtEnd()
        return
      }
      let newSelection = {}
      // 从段落起始位置选中
      if (selection.anchor.offset === 0 || selection.focus.offset === 0) {
        SlateTransforms.insertNodes(this.editor, [{ type: 'contenttype', contentType: 'content_type_0007', hyperLinkId: `${this.dayangId}`, children: [{ text }] }], {
          at: [selection.anchor.path[0]]
        })
        SlateTransforms.splitNodes(this.editor, {})

        newSelection = {
          anchor: { path: [selection.anchor.path[0], 0], offset: 0 },
          // 正向划选与逆向划选的 anchor 与 focus 可能互相颠倒
          focus: { path: [selection.focus.path[0], 0], offset: Math.abs(selection.focus.offset - selection.anchor.offset) }
        }
      }
      // 从段落非起始位置选中
      else {
        SlateTransforms.insertNodes(this.editor, [{ type: 'contenttype', contentType: 'content_type_0007', hyperLinkId: `${this.dayangId}`, children: [{ text }] }], {})
        // SlateTransforms.setNodes(this.editor,{name: `${this.dayangId}`})
        newSelection = {
          anchor: { path: [selection.anchor.path[0] + 1, 0], offset: 0 },
          // 正向划选与逆向划选的 anchor 与 focus 可能互相颠倒
          focus: { path: [selection.focus.path[0] + 1, 0], offset: Math.abs(selection.focus.offset - selection.anchor.offset) }
        }
      }
      this.editor.select(newSelection)
      this.addSelectionLinkStyle()
      this.editor.deselect()
    },
    setSectionToParagraphLink() {
      this.editor.restoreSelection()
      try {
        const selection = this.editor.selection
        const selectionNode = SlateEditor.node(this.editor, selection.anchor.path)
        const [node] = selectionNode
        // const parentNode = this.editor.getParentNode(node)

        // 没有选择文本
        if (selection.anchor.offset === selection.focus.offset) {
          console.log('no text')
          this.addLinkAtEnd()
        }

        // 选中普通文本
        if (selection) {
          this.addNewLineForLink(this.editor.getSelectionText())
        }
        // 选中链接文本 (color: blue 是自定义的mark，能够通过它来识别)
        if (node && node.color === 'blue') {
          return
        }
      } catch (e) {
        console.log('error')
        // 走到catch，代表恢复的是上一次的文本选中坐标，那么直接在底部添加链接
        this.addLinkAtEnd()
      }
    },
    hyperlinkClick() {
      this.$refs.DigitalHyperLinkRef.visible = true
    },
    editorClick(e) {
      try {
        if (e.target.parentNode.getAttribute('style').includes('color: blue;')) {
          this.getXiaoYangDetail(this.dayangId || sessionStorage.getItem('hyperLinkId'))
        }
      } catch (e) {}
    },
    getXiaoYangDetail(xiaoYangId) {
      const params = {
        id: xiaoYangId
      }
      getBook.getXiaoYangDetail(params).then((res) => {
        res = formatDigitalArticle(res)
        if (res.data.status == 0) {
          this.html = res.data.data.content
        }
      })
    },
    selectJustifyType(value) {
      this.isJustify = true
      // 恢复编辑器的选中内容及状态
      this.editor.restoreSelection()
      // 获取当前选择的内容节点
      let node = this.getSelectedNode(this.editor)
      // 更新当前内容节点
      if (node !== null) {
        if (node.type === 'contenttype' || node.type === 'paragraph') {
          let textIndent = this.handleTId(node.contentType, value)
          SlateTransforms.setNodes(this.editor, {
            justifyType: value,
            textAlign: value,
            indent: textIndent
          })
        }
      }
      // 恢复编辑器的选中内容及状态《这里主要目的用于恢复光标》
      setTimeout(() => {
        this.editor.restoreSelection()
        this.contentTypeStatus = false
        this.editorStatus = false
      }, 100)
    },
    visibleChangeJustifyType(status) {
      if (status === false) {
        if (this.editorFocus === false) {
          this.editorStatus = false
        }
      }
    },
    handleReadEffectSetingClick(command) {
      console.log(this.editorFocus)
      if (command === 'break') {
        if (this.editorFocus) {
          this.editor.restoreSelection()
          this.editor.insertNode(silent)
        }
      } else if (command === 'phoneme') {
        this.isSettingPinyin = true
        this.dialogVisible = true
      } else if (command === 'speed') {
        this.isSettingSpeed = true
        this.settingForm.speed = [50, 30, 70][this.$store.state.book.bookData.voiceSpeed]
        this.dialogVisible = true
      } else if (command === 'clear') {
        this.clearDialogVisible = true
      }
    },
    handleClearConfirm() {
      let html = this.editor.getHtml()
      let handledHtml = html.replaceAll(/<span data-w-e-type="(?:speed|pinyin|silent)"[^<]+?<\/span>/g, '').replaceAll(/<span style="background-color: rgb\(204, 228, 255\);">/g, '<span>')
      this.editor.setHtml(handledHtml)
      this.clearDialogVisible = false
    },
    insertPinyin() {
      this.editor.restoreSelection()
      let selection = this.editor.selection
      let offset = Math.max(selection.anchor.offset, selection.focus.offset)
      this.editor.select({
        anchor: { path: selection.anchor.path, offset },
        focus: { path: selection.anchor.path, offset }
      })
      this.editor.insertNode({
        type: 'pinyin',
        hanzi: this.editorSelectText,
        pinyin: this.settingForm.pinyin,
        timestamp: new Date().getTime(),
        children: [{ text: '' }]
      })
    },
    editPinyin() {
      let html = this.editor.getHtml()
      let reg = new RegExp(`data-pinyin="${this.pinyinEditElem.pinyin}" data-timestamp="${this.pinyinEditElem.timestamp}">`)
      html = html.replace(reg, `data-pinyin="${this.settingForm.pinyin}" data-timestamp="${this.pinyinEditElem.timestamp}">`)
      this.editor.setHtml(html)
    },
    editSpeed() {
      let html = this.editor.getHtml()
      let reg = new RegExp(`data-speed="${this.speedEditElem.speed}" data-timestamp="${this.speedEditElem.timestamp}">`, 'g')
      html = html.replace(reg, `data-speed="${this.settingForm.speed}" data-timestamp="${this.speedEditElem.timestamp}">`)
      this.editor.setHtml(html)
      this.handleCancel()
    },
    /**
     * 根据editor的选区确定整句坐标并返回
     * @param selection 编辑器中选区坐标： anchor（选区起点）和 focus（选区终点），
        但是可能是从后往前选，所以起点未必是头，坐标未必小，并且尾部的offset返回时会+1
        {"anchor": {"path": [8,0],"offset": 29},"focus": {"path": [7,0],"offset": 0}}
        @returns selection 整句的坐标，以便使用editor.select方法选定选取进行操作
     */
    getWholeBySelection(selection) {
      console.log(selection)
      let pathMaxLength = Math.max(selection.anchor.path.length, selection.focus.path.length)
      let isForward = true
      for (let index = 0; index < pathMaxLength; index++) {
        console.log(222)
        if (selection.focus.path[index] < selection.anchor.path[index]) {
          isForward = false
          break
        } else if (selection.focus.path[index] > selection.anchor.path[index]) {
          break
        }
        if (index === pathMaxLength - 1) {
          isForward = selection.focus.offset > selection.anchor.offset
        }
      }
      return {
        anchor: this.getFinallPointByPoint(selection[isForward ? 'anchor' : 'focus'], false),
        focus: this.getFinallPointByPoint(selection[isForward ? 'focus' : 'anchor'], true)
      }
    },
    /**
     * 根据selection中的一个点，找到最近的整句点位
     * @param {*} point 点位信息
     * @param {*} forward 方向，是向前找，还是向后找
     */
    getFinallPointByPoint(point, forward) {
      let pointNode = this.editor
      let flag = false
      let offset = point.offset
      let num = point.path.length
      let pathClone = [...point.path]
      let count = 0
      while (!flag && num > 0) {
        count++
        pointNode = this.editor
        for (let index = 0; index < num; index++) {
          pointNode = pointNode.children[pathClone[index]]
        }
        if (pointNode.text) {
          if (count > 1) {
            offset = forward ? 0 : pointNode.text.length - 1
          }
          while (offset > 0 && offset < pointNode.text.length) {
            flag = ['。', '？', '！', '；'].includes(pointNode.text[offset])
            if (!flag) {
              offset = offset + (forward ? 1 : -1)
            } else {
              if (!forward) {
                offset++
              }
              break
            }
          }
        }
        if (flag || num === 1) {
          break
        }
        if (forward) {
          if (pathClone[num - 1] === this.editor.getParentNode(pointNode).children.length - 1) {
            num--
          } else {
            pathClone[num - 1]++
          }
        } else {
          if (pathClone[num - 1] === 0) {
            num--
          } else {
            pathClone[num - 1]--
            //判断上一个兄弟node最后一个字符是不是分句标点
            if (pathClone[num - 1] >= 0) {
              let preNode = this.editor
              for (let index = 0; index < num; index++) {
                preNode = preNode.children[pathClone[index]]
              }
              if (preNode.text && ['。', '？', '！', '；'].includes[preNode.text[preNode.length - 1]]) {
                flag = true
                pathClone[num - 1]++
              }
            }
          }
        }
      }
      let res = {
        path: [],
        offset: 0
      }
      if (flag) {
        for (let index = 0; index < num; index++) {
          res.path.push(pathClone[index])
        }
        res.offset = offset
        //修复最后的标点不选中的问题
        if (forward) {
          res.offset++
        }
      } else {
        let node = this.editor
        for (let index = 0; index < pathClone.length; index++) {
          res.path.push(pathClone[index])
          node = node.children[pathClone[index]]
          if (node.text !== null && node.text !== undefined) {
            if (forward) {
              res.offset = node.text.length
            } else {
              res.offset = 0
            }
            break
          }
        }
      }
      console.log(res)
      return res
    },
    handleSettingConfirm() {
      if (this.isSettingPinyin) {
        this.$refs.settingDialogForm.validateField('pinyin', (err) => {
          if (!err) {
            if (this.pinyinEditElem) {
              this.editPinyin()
            } else {
              this.insertPinyin()
            }
            this.handleCancel()
          }
        })
      } else if (this.isSettingSpeed) {
        this.$refs.settingDialogForm.validateField('speed', (err) => {
          if (!err) {
            if (this.speedEditElem) {
              this.editSpeed()
              return
            }
            this.editor.restoreSelection()
            let selection = this.getWholeBySelection(this.editor.selection)
            console.log(selection)
            let timestamp = new Date().getTime()
            this.editor.select(selection)
            this.editor.addMark('bgColor', '#CCE4FF')
            selection = this.editor.selection
            setTimeout(() => {
              this.editor.select({
                anchor: {
                  path: selection.focus.path,
                  offset: selection.focus.offset
                },
                focus: {
                  path: selection.focus.path,
                  offset: selection.focus.offset
                }
              })
              this.editor.insertNode({
                type: 'speed',
                speed: this.settingForm.speed,
                start: false,
                timestamp,
                children: [{ text: '' }]
              })
              setTimeout(() => {
                this.editor.select({
                  anchor: {
                    path: selection.anchor.path,
                    offset: selection.anchor.offset
                  },
                  focus: {
                    path: selection.anchor.path,
                    offset: selection.anchor.offset
                  }
                })
                this.editor.insertNode({
                  type: 'speed',
                  speed: this.settingForm.speed,
                  start: true,
                  timestamp,
                  children: [{ text: '' }]
                })
                this.handleCancel()
              }, 100)
            }, 100)
          }
        })
      }
    },
    handleCancel() {
      this.dialogVisible = false
      this.isSettingPinyin = false
      this.isSettingSpeed = false
      this.settingForm.pinyin = ''
      this.settingForm.speed = ''
      this.pinyinEditElem = null
      this.speedEditElem = null
    },
    handleEditorDelete(e) {
      console.log('handleEditorDelete', e.key)
    },
    handleCustomEditorToolbarItemClick(type) {
      console.log($(`[data-menu-key="${type}"]`))
      $(`[data-menu-key="${type}"]`)[0].click()
    }
  },
  mounted() {
    this.registerModule()
    this.debouncedSettingConfirm = debounce(this.handleSettingConfirm, 200, {
      leading: true, // 立即触发第一次点击
      trailing: false // 不触发最后一次延迟点击
    })
    // 以下代码用于解决BUG517826的问题
    $('#content_type_select')
      .parent()
      .find('.el-input__suffix')
      .mouseover(() => {
        this.contentTypeStatus = true
      })
      .mouseout(() => {
        this.contentTypeStatus = false
      })
    $('#content_type_select')
      .mouseover(() => {
        this.contentTypeStatus = true
      })
      .mouseout(() => {
        this.contentTypeStatus = false
      })
  },
  beforeDestroy() {
    const editor = this.editor
    if (editor == null) return
    editor.destroy() // 组件销毁时，及时销毁编辑器
  }
}
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="scss">
.rich {
  height: 100%;
  .type {
    position: relative;
    margin: 15px 0;
    height: 28px;
    .label {
      position: absolute;
      top: 0;
      left: 0;
      line-height: 28px;
      z-index: 1;
    }
    .form {
      margin-left: 70px;
      .el-select {
        width: 100%;
      }
      img {
        width: 20px;
        margin-right: 20px;
        vertical-align: middle;
        cursor: pointer;
      }
      .gray {
        filter: grayscale(100%);
        /* 降低透明度，增强不可用视觉 */
        opacity: 0.7;
        /* 禁止鼠标交互（无法点击、选中） */
        pointer-events: none;
        /* 可选：添加轻微缩放或边框，强化状态区分 */
        transform: scale(0.98);
      }
    }
  }
  .btns {
    display: flex;
    margin: 15px 0;
    .btn {
      flex: 1;
      position: relative;
      background: #ffffff;
      border: 1px solid #dcdfe6;
      color: #606266;
      font-weight: 500;
      padding: 7px 15px;
      font-size: 12px;
      border-radius: 3px;
      margin-right: 10px;
      cursor: pointer;
      .el-upload {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        line-height: 26px;
        text-align: center;
      }
      &:hover {
        color: #df5813;
        border-color: #f5cdb8;
        background-color: #fceee7;
      }
      &:active {
        color: #c94f11;
        border-color: #c94f11;
      }
    }
    button {
      flex: 1;
    }
  }
  .editor {
    height: calc(100% - 215px);
    .editor-root {
      height: 100%;
    }
    .w-e-bar {
      background-color: #f3f3f3;
    }
  }
  .custom-editor-toolbar {
    .form {
      display: flex;
      height: 28px;
      align-items: center;
    }
    .btn {
      width: 15px;
      height: 15px;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: contain;
      flex-grow: 0;
      flex-shrink: 0;
      margin-left: 24px;
      cursor: not-allowed;
      pointer-events: none;
      &.active {
        cursor: pointer;
        pointer-events: auto;
      }
      &:first-child {
        margin-left: 0;
      }
    }
    .bold {
      background-image: url('~@imgs/editor/inactive/bold.png');
    }

    .italic {
      background-image: url('~@imgs/editor/inactive/italic.png');
    }

    .underline {
      background-image: url('~@imgs/editor/inactive/underline.png');
    }

    .spaces {
      background-image: url('~@imgs/editor/inactive/spaces.png');
    }

    .link {
      background-image: url('~@imgs/editor/inactive/link.png');
    }

    .undo {
      background-image: url('~@imgs/editor/inactive/undo.png');
    }

    .redo {
      background-image: url('~@imgs/editor/inactive/redo.png');
    }

    .pause {
      background-image: url('~@imgs/editor/inactive/pause.png');
    }
    .pause.active {
      background-image: url('~@imgs/editor/active/pause.png');
    }
    .speed {
      background-image: url('~@imgs/editor/inactive/speed.png');
    }
    .speed.active {
      background-image: url('~@imgs/editor/active/speed.png');
    }
    .pinyin {
      background-image: url('~@imgs/editor/inactive/pinyin.png');
    }
    .pinyin.active {
      background-image: url('~@imgs/editor/active/pinyin.png');
    }
    .clear {
      background-image: url('~@imgs/editor/inactive/clear.png');
    }
    .clear.active {
      background-image: url('~@imgs/editor/active/clear.png');
    }
    &.active {
      .btn {
        cursor: pointer;
        pointer-events: auto;
      }
      .bold {
        background-image: url('~@imgs/editor/active/bold.png');
      }
      .italic {
        background-image: url('~@imgs/editor/active/italic.png');
      }
      .underline {
        background-image: url('~@imgs/editor/active/underline.png');
      }
      .spaces {
        background-image: url('~@imgs/editor/active/spaces.png');
      }
      .link {
        background-image: url('~@imgs/editor/active/link.png');
      }
      .undo {
        background-image: url('~@imgs/editor/active/undo.png');
      }
      .redo {
        background-image: url('~@imgs/editor/active/redo.png');
      }
    }
  }
}
.setting-dialog,
.clear-confirm-dialog {
  .dialog-footer {
    display: flex;
    justify-content: center;
    margin-top: 30px;
    .dialog-footer-item {
      cursor: pointer;
      line-height: 39px;
      width: 95px;
      text-align: center;
    }
    .dialog-footer-item:first-child {
      margin-right: 20px;
    }
  }
  .confirm {
    background: rgba(223, 88, 19, 1);
    color: #fff;
  }
  .cancel {
    border: 1px solid rgba(223, 88, 19, 1);
  }
  .editorSelectText {
    text-align: center;
    font-size: 20px;
    margin-bottom: 10px;
  }
  .prompt {
    font-size: 12px;
    text-align: center;
  }
}
.clear-confirm-dialog .dialog-footer {
  .dialog-footer-item {
    line-height: 27px;
    width: 78px;
    font-size: 12px;
  }
}
</style>
<style>
/* 这里是用于编辑器的编辑模式下的样式《不适用于展示模式》 */
.editor-root .w-e-image-container {
  display: block !important;
  margin: auto !important;
}
.editor-root .w-e-textarea-video-container {
  padding: 0 !important;
  font-size: 0 !important;
  border-radius: 0 !important;
}
.editor-root .content_audio {
  display: block !important;
  margin: auto !important;
  width: 100% !important;
  background: #f3f3f3 !important;
  font-size: 0 !important;
  line-height: 0 !important;
}
.editor-root .content_audio audio {
  width: 100% !important;
}
.editor-root video {
  display: block !important;
  margin: auto !important;
  width: 100% !important;
}
</style>
<style>
/* 这里是用于编辑器的展示模式下的样式《适用于编辑模式》 */
.editor_preview .content_type {
  /* 全局样式控制 */
}
.editor_preview .content_type img {
  /* 全局图片 */
  display: block !important;
  margin: auto !important;
  max-width: 100% !important;
}
.editor_preview .content_audio {
  display: block !important;
  margin: auto !important;
  width: 100% !important;
  background: #f3f3f3 !important;
  font-size: 0 !important;
  line-height: 0 !important;
}
.editor_preview .content_audio audio {
  /* 全局音频 */
  max-width: 100% !important;
}
.editor_preview video {
  /* 全局视频 */
  display: block !important;
  margin: auto !important;
  max-width: 100% !important;
}
.editor_preview .content_type_0001 {
  /* 引题 */
  font-size: 16px !important;
  line-height: 28px !important;
  text-align: justify;
  color: #777777 !important;
}
.editor_preview .content_type_0002 {
  /* 标题 */
  font-size: 22px !important;
  line-height: 34px !important;
  text-align: justify;
  color: #000000 !important;
}
.editor_preview .content_type_0003 {
  /* 副标题 */
  font-size: 16px !important;
  line-height: 28px !important;
  text-align: justify;
  color: #777777 !important;
  margin-top: 20px;
}
.editor_preview .content_type_0004 {
  /* 摘要 */
  font-size: 16px !important;
  line-height: 28px !important;
  text-align: justify;
  color: #000000 !important;
  text-indent: 2em;
  margin: 20px 6px !important;
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}
.editor_preview .content_type_0004:not(.content_type_0004 ~ .content_type_0004) {
  /* 摘要 */
  border-top: 1px dotted #777777 !important;
}
.content_type_0004:last-of-type {
  /* 摘要 */
  border-bottom: 1px dotted #777777 !important;
}
.editor_preview .content_type_0005 {
  /* 作者 */
  font-size: 14px !important;
  line-height: 22px !important;
  text-align: left;
  color: #777777 !important;
  margin-top: 20px;
}
.editor_preview .content_type_0006 {
  /* 图片说明 */
  font-size: 14px !important;
  line-height: 22px !important;
  text-align: center;
  color: #777777 !important;
}
.editor_preview .content_type_0007 .w-e-image-container .w-e-image-dragger {
  display: none;
}
.editor_preview .content_type_0007 .w-e-image-container {
  width: unset !important;
  display: inline !important;
}
.editor_preview .content_type_0007 img {
  width: auto !important;
  height: 29px !important;
}
.editor_preview .content_type_0006 .w-e-image-container img {
  height: 100% !important;
}
.editor_preview .content_type_0006 .w-e-image-container .w-e-image-dragger {
  display: block !important;
}
.editor_preview .content_type_0006 .w-e-image-container {
  display: block !important;
}
.editor_preview .content_type_0007 {
  /* 内容 */
  font-size: 16px !important;
  line-height: 29px !important;
  text-align: justify;
  color: #000000 !important;
  text-indent: 2em;
  /*margin-top: 20px;*/
}
.editor_preview .content_type_0007::selection {
  text-decoration: #00a4ff;
}
.editor_preview .content_type_0007 u {
  cursor: pointer;
}
.editor_preview .content_type_0008 {
  /* 小标题 */
  font-size: 16px !important;
  line-height: 29px !important;
  text-align: center;
  color: #000000 !important;
  margin: 12px 0 !important;
}
.editor_preview .content_type_0009 {
  /* 来源 */
  font-size: 12px !important;
  line-height: 18px !important;
  text-align: left;
  text-indent: 0 !important;
  color: #000000 !important;
  margin: 12px 0 !important;
  margin-left: 5em !important;
}
.editor_preview .content_hyper_link {
  text-decoration: #00a4ff;
  color: #00a4ff;
}
.editor_preview .break {
  padding: 0 6px;
  border-radius: 3px;
  background: rgba(252, 202, 214, 1);
  border: 1px solid rgba(212, 48, 48, 1);
  color: rgba(212, 48, 48, 1);
}
.editor_preview .pinyin {
  border-radius: 3px;
  background: rgba(212, 252, 234, 1);
  border: 1px solid rgba(12, 133, 60, 1);
  color: rgba(12, 133, 60, 1);
  padding: 0 6px;
  cursor: pointer;
}
.editor_preview .speed {
  border-radius: 3px;
  background: rgba(204, 228, 255, 1);
  border: 1px solid rgba(42, 130, 228, 1);
  color: rgba(42, 130, 228, 1);
  padding: 0 6px;
  cursor: pointer;
}
.w-e-bar svg {
  width: 16px;
  height: 16px;
}
</style>
